import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-instagram',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M21.5 4.5v15c0 1.1046-.8954 2-2 2h-15c-1.10457 0-2-.8954-2-2v-15c0-1.10457.89543-2 2-2h15c1.1046 0 2 .89543 2 2Z" />
      <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5"
            d="M16.5 12c0 2.4853-2.0147 4.5-4.5 4.5-2.48528 0-4.5-2.0147-4.5-4.5 0-2.48528 2.01472-4.5 4.5-4.5 2.4853 0 4.5 2.01472 4.5 4.5Z" />
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M17.5078 6.5h-.009" />
    </svg>
  `
})
export class IconInstagramComponent {
  size: InputSignal<number> = input<number>(24);
}
